export function createUrlGenerator({
  categoryId,
  fieldset,
  origin,
  sort,
  baseUrl = window.location.origin,
  throwOnEmptyFilters,
  template,
  site,
  pagination,
  serializeFn = () => [],
  defaultTableFilter = [],
}) {
  return function generateUrl({ filters = {} }) {
    const shouldThrowUrlError = throwOnEmptyFilters && !Object.keys(filters).length;

    if (shouldThrowUrlError) {
      throw new Error('Filters are missing to generate the url');
    }

    const urlParts = [
      `${baseUrl}/wordpress/wp-admin/admin-ajax.php?action=redraw_table_ajax`,
      `template=${template}`,
      `site=${site}`,
      `category=${categoryId}`,
      `fieldset=${fieldset}`,
      `origin=${origin}`,
      `sort=${sort}`,
      'disable_default_filter_from_filter_builder=true',
    ];

    const filtersPart = serializeFn(filters, defaultTableFilter);
    if (filtersPart.length) {
      urlParts.push(...filtersPart);
    }

    if (pagination) {
      urlParts.push('offset=0');
      urlParts.push(`page-size=${pagination}`);
    }

    return urlParts.join('&');
  };
}



// WEBPACK FOOTER //
// ./src/utils/UrlGenerator.js